module.exports = {
  PluginManifest: require('./lib/PluginManifest'),
  PluginStore: require('./lib/PluginStore'),
}



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/graylog-web-plugin/plugin.js
// module id = 47
// module chunks = 0